// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7365) return "static/chunks/7365.74d9e643a308fec5.js";
	if (chunkId === 3800) return "static/chunks/3800.d7a4607b45bc8edf.js";
	if (chunkId === 6783) return "static/chunks/6783.17f2fb2a8d80cfa1.js";
	if (chunkId === 1402) return "static/chunks/1402.b367d88e68f741b6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"19":"1f939d587444f697","2505":"32775a343316b5ce","3850":"69678ef8a2030b20","5608":"5211b6db3357ebfb","6398":"5fe7c2b8a5b206ad","6435":"197fbba1974b8e41"}[chunkId] + ".js";
};